import styles from './ServerErrorPage.module.scss';

export default function ServerErrorPage() {
   return (
      <div className={styles.error}>
         <h1>Server error</h1>
      </div>
   );
}
